import { Component, Injector, OnInit } from '@angular/core';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { UsersService } from '@services/entity/users.service';
import { InvoicesService } from '@services/entity/invoices.service';
import { UserDto } from '@dto/userDto';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionsService } from '@services/entity/transactions.service';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { CustomersService } from '@services/entity/customers.service';
import { CreditStatementsService } from '@services/entity/credit-statements.service';
import { CreditStatementTableData } from '@dto/creditStatementTableData';
import { ToastService } from '@services/toast/toast.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'credit-statements',
  templateUrl: './credit-statements.component.html',
  styleUrls: ['./credit-statements.component.scss'],
})
export class CreditStatementsComponent implements OnInit {

  public className = 'CreditStatementsComponent'

  public user: UserDto
  public users: UserDto[]
  public selectedUser: UserDto

  public isOperator: boolean = false
  public isCustomer: boolean = false
  public isUser: boolean = false

  public form: FormGroup;
  public isFormReady: boolean = false;
  public customerId: number
  public scheduledCreditDate: Date
  public creditStatements: CreditStatementTableData[] = []

  constructor(
    public tableFunctions: TableFunctionsService,
    public router: Router,
    public datePipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    public transactionsService: TransactionsService,
    public usersService: UsersService,
    public creditStatementsService: CreditStatementsService,
    public customersService: CustomersService,
    public pricingsService: PricingsService,
    public invoicesService: InvoicesService,
    public authenticationService: AuthenticationService,
    public stripeInfosService: StripeInfosService,
    public toastService: ToastService,
    injector: Injector
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit(): void {
    const customerId = localStorage.getItem('customerId')
    if (customerId) this.customerId = parseInt(customerId)

    this.getRoles()
    this.setScheduledCreditDate()
    this.getCreditStatements()
    this.getUsers()
    this.createForm()
  }

  setScheduledCreditDate(): void {
    const now = new Date()
    let date: number = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)

    if (now.getDate() > 2) {
      date = Date.UTC(now.getFullYear(), now.getMonth() + 1, now.getDate(), 0, 0, 0, 0)
    }

    this.scheduledCreditDate = new Date(date)
  }

  async getCreditStatements() {
    this.creditStatementsService.getCreditStatementsAsTableData().subscribe(creditStatements => {
      this.creditStatements = creditStatements
    }, error => console.error(error))
  }
  
  async download(creditStatement: CreditStatementTableData) {
    this.toastService.loading('Gutschriftsbeleg wird heruntergeladen...')
    this.creditStatementsService.downloadCreditStatement(creditStatement.id).subscribe((response: any) => {
      const file = new Blob([response], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);
      const fileName = `${creditStatement.documentNumber}.pdf`

      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = fileUrl;
      a.download = fileName;
      a.click();

      window.URL.revokeObjectURL(fileUrl);
      this.toastService.success('Gutschriftsbeleg erfolgreich heruntergeladen.', 0, true)
    },
    error => {
      console.error(error);
      this.toastService.error(`Gutschriftsbeleg konnte nicht heruntergeladen werden.`, 0, true)
    })
  }

  async getUsers() {
    if (!this.customerId) return;

    if (this.isOperator) {
      // Todo: Receive customer id from input or something
      this.users = await this.usersService.getUsersOfCustomerAsync(this.customerId);
    } else {
      this.users = await this.usersService.getUsersOfCurrentCustomerAsync();
    }
  }

  createForm() {
    this.form = new FormGroup({
      company: new FormControl(),
      ceo: new FormControl(),
      street: new FormControl(),
      houseNumber: new FormControl(),
    });

    this.isFormReady = true;
    this.loadRecipient()
  }

  loadRecipient() {
    if (!this.selectedUser) return;

    this.form.setValue({
      company: this.selectedUser.company,
      ceo: this.selectedUser.fullName,
      street: this.selectedUser.street,
      houseNumber: this.selectedUser.houseNumber,
    })
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
  }
}